'use client'

import type { CSSProperties, ReactNode } from 'react'

export interface FeatureCardData {
  id: 'voice-design' | 'voice-clone'
  title: string
  subtitle: string
  accent: string
  accentSoft: string
  tint: string
  art: ReactNode
}

interface FeatureCardProps {
  feature: FeatureCardData
  onClick?: () => void
}

/**
 * Plaza 顶部 2 个特性入口卡（Voice Design / Voice Clone）
 * 高 180px、圆角 20px、hover 上浮 2px + 边框变亮
 */
export const FeatureCard = ({ feature, onClick }: FeatureCardProps) => {
  return (
    <button
      className="group relative h-[140px] w-full min-w-0 cursor-pointer overflow-hidden rounded-[var(--voice-r-xl)] border border-[var(--border)] bg-[var(--surface)] bg-[image:var(--fc-bg)] p-0 text-left transition-[transform,border-color,background] duration-[250ms] [font-family:inherit] hover:-translate-y-0.5 hover:border-[var(--border-active)] md:h-[180px]"
      type="button"
      style={
        {
          '--fc-bg': feature.tint
            ? `linear-gradient(135deg, ${feature.tint}, transparent 60%)`
            : 'none',
          '--fc-soft': `radial-gradient(circle, ${feature.accentSoft}, transparent 60%)`,
        } as CSSProperties
      }
      onClick={onClick}
    >
      {feature.accentSoft && (
        <div className="pointer-events-none absolute right-[-60px] top-1/2 h-[200px] w-[200px] -translate-y-1/2 bg-[image:var(--fc-soft)] opacity-[0.85] transition-opacity duration-[250ms] group-hover:opacity-100 md:h-[380px] md:w-[380px]" />
      )}
      <div className="pointer-events-none absolute -bottom-2 -right-1 h-[70px] w-[85px] opacity-80 md:-bottom-5 md:-right-2.5 md:h-[140px] md:w-[180px] md:opacity-95">
        {feature.art}
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(90deg,var(--surface)_0%,var(--surface)_35%,rgba(36,36,36,0.45)_65%,transparent_95%)]" />
      <div className="relative z-[1] flex h-full min-w-0 flex-col justify-start px-3.5 py-4 md:px-6 md:py-7">
        <div className="voice-display truncate text-[15px] font-semibold leading-[1.2] tracking-[-0.02em] text-[var(--text-1)] md:whitespace-nowrap md:text-[26px]">
          {feature.title}
        </div>
        <div className="mt-1.5 line-clamp-2 text-[11px] leading-[1.4] text-[var(--text-3)] md:mt-2.5 md:line-clamp-none md:min-h-[38px] md:max-w-[60%] md:text-[13px] md:leading-[1.5]">
          {feature.subtitle}
        </div>
      </div>
    </button>
  )
}
